<template>
    <div v-if="showInfoModal">
        <div class="popupModal" :class="{active: showInfoModal}">
            <div class="popupModal__wrapper">
                <div class="popupModal__content">
                    <div>
                         <span class="close-icon" @click="onClose">
                             <img src="@/assets/icons/ic_close_white.svg">
                        </span>
                    </div>
                    <div class="main-content">
                        <h3 class="main-content__title">{{translate('manageGPSAllowTitle')}}</h3>
                        <div class="main-content__text">
                            {{translate('manageGPSAllowText')}}
                        </div>
                    </div>
                    <template>
                        <div v-if="!settings.hideOkButton" class="footer-ok__btn" variant="primary" @click="onOk">
                            <template v-if="settings.okButtonText">{{ settings.okButtonText }}</template>
                            <template v-else>{{translate('OK')}}</template>
                        </div>
                        <div v-if="settings.showCancelButton" class="footer-cancel__btn" @click="onClose">
                            <template v-if="settings.cancelButtonText">{{ settings.cancelButtonText }}</template>
                            <template v-else>{{ translate('Cancel') }}</template>
                        </div>

                    </template>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import logAnalyticsEvent from '@/helpers/analytics'
    import errorMixin from '@/mixins/errorMixin';


    export default {
        name: "explainGeolactionPopup",

        mixins: [mixin, errorMixin],

        data() {
            return {
                showInfoModal: this.settings !== null,
            }
        },

        watch: {
            settings(newValue) {
                this.showInfoModal = newValue !== null
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },

        methods: {
            async onClose() {
                logAnalyticsEvent('geo_popup_close_click')
                this.showInfoModal = false
                if (this.settings.onCancelHandler) {
                    try {
                        await this.settings.onCancelHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            async onOk() {
                logAnalyticsEvent('geo_popup_allow_click')
                this.showInfoModal = false
                if (this.settings.onOkHandler) {
                    try {
                        await this.settings.onOkHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },
        }

    }
</script>

<style scoped>
    .footer-ok__btn {
        background: #3F405C;
        border-radius: 6px;
        padding: 12px;
        color: white;
        text-align: center;
        margin-bottom: 10px;
        cursor: pointer;
    }
    .footer-cancel__btn {
        text-align: center;
        padding: 12px;
        border-radius: 6px;
        cursor: pointer;
    }
    .main-content {
        text-align: center;
        color: black;
        margin-bottom: 25px;
        margin-top: 25px;
    }
    .close-icon {
        position: absolute;
        right: 10px;
        z-index: 99999;
    }
    .main-content__title {
        margin-top: 0;
        color: black;
        margin-bottom: 20px;
    }


</style>